// components/ui/list/paginated-list.js
import React from 'react';
import PropTypes from 'prop-types';
import { List, ListSubheader } from '@mui/material';
import Pagination from 'src/components/ui/pagination';

const PaginatedList = (props) => {
  const {
    items = [],
    loading,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    renderItem, // Function to render items, receives each item as an argument
    children, // Use children for the header
  } = props;

  return (
    <>
      <List
        sx={{ minHeight: '55vh', display: 'block', overflowY: 'auto' }}
        subheader={
          <ListSubheader
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.50',
              display: 'flex', // Flexbox for alignment
              justifyContent: 'space-between',
              p: 1
            }}
          >
            {children}
          </ListSubheader>
        }
      >
      {Array.isArray(items) && (items.length > 0) && (
        items.map((item, index) => {
          // Define row background color based on theme mode
          const rowstyle = {
            backgroundColor: (theme) =>
              index % 2 === 0
                ? theme.palette.mode === "dark"
                  ? "rgba(0, 0, 0, 1)" 
                  : "rgba(255, 255, 255, 1)"
                : theme.palette.mode === "dark"
                ? "rgba(0, 0, 0, 0.1)"
                : "rgba(200, 200, 200, 0.1)",
            '&:hover': {
              backgroundColor: 'action.hover',
              cursor: 'pointer',
            },
            px: 0,
            py: 1,
          };
          return (
            <React.Fragment key={index}>
              {renderItem(item, rowstyle, index)}
            </React.Fragment>
          );
        }
        ))
      }
      </List>
      <Pagination
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  );
};

PaginatedList.propTypes = {
  items: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  renderItem: PropTypes.func.isRequired,
  children: PropTypes.node, // Only children for the header
};

export default PaginatedList;

{
  // How to use
  // Function to render each item or using redirect
  // renderItem = (item) = (<>Binding item</>)
  // HEADER
  // import Typography from '@mui/material/Typography';
  // <Typography sx={itemStyle} variant="body2">{t(...)}</Typography>
  // <Typography sx={itemStyle} variant="body2">NAME</Typography>
  // <Typography sx={{ ...itemStyle, textAlign: 'right' }} variant="body2">ACTION</Typography>
  // BODY
  // import PaginatedList from 'src/components/ui/list/paginated-list';
  // import { ListItem, ListItemText } from '@mui/material';
  // const renderItem = (item) => (
  //     <ListItem divider={true} key={item.id}
  //         sx={{
  //           '&:hover': {
  //             backgroundColor: 'action.hover',
  //             cursor: 'pointer',
  //           },
  //         }}
  //       >
  //       <ListItemText sx={{ width: '20%' }}>{item.id}</ListItemText>
  //       <ListItemText sx={{ width: '20%' }}>{item.name}</ListItemText>
  //       <ListItemText align="right">
  //         <button onClick={() => showLog("Edit", item.id)}>Edit</button>
  //       </ListItemText>
  //       {/* <Divider /> */}
  //     </ListItem>
  // );
  // return (
  //   <Box sx={{ position: "relative" }}>
  //     <PaginatedList
  //         items={items}             // Pass fetchItems to load items per page
  //         renderItem={renderItem}             // Pass renderItem for each item rendering
  //         page={page}        // Current page from dataSearch
  //         rowsPerPage={rowsPerPage}  // Rows per page
  //         onPageChange={onPageChange} // Page change handler
  //         onRowsPerPageChange={onRowsPerPageChange} // Rows per page change
  //     >
  //       <>Header view at here</>
  //     </PaginatedList>
  //   </Box>
  // );
}
